export default __webpack_public_path__ + "static/media/rr-logo.94065bc6.png";